<div
  *ngIf="pastDue.enabled() && isBuyer && pastDueCount > 0"
  class="alert alert-danger past-due-banner mb-0"
  role="alert"
  style="cursor: pointer;"
  (click)="pastDue.routeToPastDue(pastDueSummary, facilityId)"
  data-testid="buyer-past-due-banner"
>
  You have {{ pastDueCount }} past due orders &middot; {{ pastDueAmount | currency }}. Pay now
</div>
